<template>
    <v-card width="100%">
        <v-layout row wrap xs12 px-3>
            <h3>Sessions concours :</h3>
            <hr size="5" width="100%" color="secondary">
        </v-layout>
        <v-data-table :headers="headers"
                      :items="FiltreSession"
                      class="elevation-1"
                      disable-pagination hide-default-footer>
            <template v-slot:item="{item}" :rules="[$rules.sessionCochee($storeCandidature.sasCandidature.SessionChoisie,$storeCandidature.langueFormulaire)]">
                <!-- si l'étudiant a renseigné un campus on filtre la liste des sessions sinon on ne la filtre pas-->
                <tr v-if="(!modeValidation || item.ChoixOk)">
                    <th class="text-xs-left">{{ formatDate(item.Date) }}</th>
                    <th class="text-xs-left">{{ item.Lieu ? ($storeCandidature.langueFormulaire == 'en' ? item.Lieu.Lang01 : item.Lieu.Lang00) : '' }}</th>
                    <th class="text-xs-left">{{ item.Adresse}}</th>
                    <th>
                        <v-checkbox v-model="item.ChoixOk"
                                    hide-details
                                    @change="choixSessionsCoche(item)"
                                    :readonly="modeValidation"
                                    :rules="[$rules.sessionCochee($storeCandidature.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher,$storeCandidature.sasCandidature.SessionChoisie,$storeCandidature.langueFormulaire)]">
                        </v-checkbox>
                    </th>
                </tr>
            </template>
        </v-data-table>
        <v-layout>
            <span class="ml-2 text-xs-left red--text" v-if="$storeCandidature.sasCandidature.SessionChoisie == null || !$storeCandidature.sasCandidature.SessionChoisie.Id || $storeCandidature.sasCandidature.SessionChoisie.Id == 0">
                {{$storeCandidature.langueFormulaire == 'en' ? 'You must choose a session !' : 'Vous devez choisir une session concours !'}}
            </span>
        </v-layout>
    </v-card>
</template>

<script>
    export default {
        props: {
            modeValidation: {
                default: false
            }
        },
        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,
                //Header list
                headers: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Session date' : 'Date de la session', value: 'date' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Location' : 'Lieu', value: 'lieu' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Details & address' : 'Détails & adresse', value: 'adresse' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Subscribe' : 'S\'inscrire', value: 'choix', sortable: false }
                ]
            }
        },
        computed: {
            FiltreSession() {

                if (this.$storeCandidature.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher
                    && this.$storeCandidature.sasCandidature.ChoixProgramme
                    && this.$storeCandidature.sasCandidature.ChoixProgramme.Campus) {

                    return this.$storeCandidature.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher
                        .filter(item => item.Lieu != null)
                        .filter(item => item.Lieu.Id == this.$storeCandidature.sasCandidature.ChoixProgramme.Campus.Id
                            || item.Lieu.Id == this.$storeCandidature.configurationClient.DataIdEnLigne);

                } else {
                    return this.$storeCandidature.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher
                }
            },
        },


        methods: {
            // Mettre la prmière lettre en majuscule
            capitalise(chaine) {
                if (chaine)
                    return chaine.charAt(0).toUpperCase() + chaine.slice(1);
                else
                    return ""
            },

            // Formatage de la date
            formatDate(date) {
                if (date) {
                    return this.capitalise(this.$moment(String(date)).format('dddd Do MMMM  YYYY'));
                }
                else { return '' }
            },

            choixSessionsCoche(item) {
                if (item.ChoixOk) {
                    // Affecter la SessionChoisie de la candidature et désélectionner les autre cases
                    this.$storeCandidature.sasCandidature.SessionChoisie = { Id: item.Id, Date: item.Date }

                    for (var i = 0; i < this.$storeCandidature.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher.length; i++) {
                        if (this.$storeCandidature.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher[i].Id != this.$storeCandidature.sasCandidature.SessionChoisie.Id) {
                            this.$storeCandidature.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher[i].ChoixOk = false
                        }
                    }
                }
                else {
                    this.$storeCandidature.sasCandidature.SessionChoisie = null
                }

                this.$storeCandidature.candidatureChanged = true
            },
        }
    }
</script>

<style scoped>
</style>